import { FC, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import RedesignModal from '../../../shared/components/RedesignModal';
import { HelpModalConfirmation } from './HelpModalConfirmation';
import { HelpModalForm } from './HelpModalForm';
import { useHelpModalStyles } from './HelpModal.styles';

interface HelpModalProps {
  open: boolean;
  onClose: () => void;
  defaultEmail?: string;
  defaultName?: string;
  defaultFirstName?: string;
}

const HelpModal: FC<HelpModalProps> = ({
  open,
  onClose,
  defaultEmail = '',
  defaultName = '',
  defaultFirstName = '',
}) => {
  const cls = useHelpModalStyles();
  const history = useHistory();
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    if (!open) {
      setSubmitted(false);
    }
  }, [open]);

  const handleTakeTest = () => {
    onClose();
    history.push('/signup');
  };

  return (
    <RedesignModal
      open={open}
      onClose={onClose}
      labelledBy="help-modal-title"
      paperClassName={submitted ? cls.helpConfirmPaper : cls.helpPaper}
      zIndex={1304}
      lightBackdrop={true}>
      {submitted ? (
        <HelpModalConfirmation onClose={onClose} onTakeTest={handleTakeTest} />
      ) : (
        <HelpModalForm
          onClose={onClose}
          onSuccess={() => setSubmitted(true)}
          defaultEmail={defaultEmail}
          defaultName={defaultName}
          defaultFirstName={defaultFirstName}
        />
      )}
    </RedesignModal>
  );
};

export default HelpModal;
